import './index.scss';

import $ from "jquery";

import customProtocolCheck from "custom-protocol-check";

$( document ).ready( function() {

    // https://www.menubles.com/view?id=cce4c6f0-7ec5-4c21-82dd-d5726163774d&diningType=DINEIN&table=10
    // menubles://?id=cce4c6f0-7ec5-4c21-82dd-d5726163774d&diningType=DINEIN&table=1

    let ua = navigator.userAgent;

    let isAndroid = /android/i.test(ua);   // Android system or uc browser
    let isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);   // iOS system

    let queryString = window.location.search;

    let urlParams = new URLSearchParams( queryString );

    let restaurantId = urlParams.get( 'id' );
    let diningType = urlParams.get( 'diningType' );
    let table = urlParams.get( 'table' );

    let fallback = ''

    if ( isIOS ) {

      const urlScheme = "menubles://?id=" + restaurantId + "&diningType=" + diningType + "&table=" + table;
      const fallback = "https://apps.apple.com/ca/app/menubles/id1574063950";

      window.location.href = urlScheme;

      setTimeout( () => {

        window.location.href = fallback

      }, 5000 )

      return

    }

    if ( isAndroid ) {

      const fallback = "https://play.google.com/store/apps/details?id=com.menubles.customer";
      const urlScheme = "intent://menubles" + "?id=" + restaurantId + "&diningType=" + diningType + "&table=" + table + "#Intent;scheme=menubles;package=com.menubles.customer;S.browser_fallback_url=" + fallback + ";end"

      window.location.href = urlScheme;

      return;

    }

} );
